<template>
<div class="OrgCard">
        <CardContentLoader v-if="loading" />

        <ResourceCard
            v-else-if="org"
            :id="org.id"
            :badge-main="activeOpportunitiesCountLabel"
            :badge-text="orgType"
            button-text="Zobraziť"
            :fixed-width="fixedWidth"
            :heading="org.title"
            :image="org.image"
            image-type="org"
            :pills="org.interests"
            :preview="preview"
            :return-route="returnRoute"
            :search-tag-query-param="searchTagQueryParam"
            :search-tag-route-name="searchTagRouteName"
            :to="{ name: 'orgs-id', params: { id: org.slug || org.id } }"
        >

                <IconTextRow v-if="location" icon="location" variant="default" slim>
                    {{ location }}
                </IconTextRow>

        </ResourceCard>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { BadgeMainType } from '#shared/types/Badge'
import type { Org, OrgIndexed } from '#shared/types/Org'
import { OrgType } from '#shared/types/Org'
import IconTextRow from '@/components/common/IconTextRow.vue'
import CIcon from '@/components/ui/CIcon.vue'
import CBadge from '@/components/ui/CBadge.vue'
import CTags from '@/components/ui/CTags.vue'
import { orgTypeDictionary } from '#shared/types/dictionary'
import CSearchTags from '../ui/CSearchTags.vue'

interface Props {
    org: Org | OrgIndexed
    returnRoute?: Record<string, any>
    searchTagRouteName?: string
    searchTagQueryParam?: string
    loading?: boolean
    badgeMain?: boolean
    preview?: boolean
    fixedWidth?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    returnRoute: () => ({}),
    searchTagRouteName: 'organizacie',
    searchTagQueryParam: 'hashtag',
    loading: false,
    badgeMain: false,
    preview: false,
    fixedWidth: false
})

const { t: $t, t } = useI18n()

const activeOpportunitiesCountLabel = computed<BadgeMainType>(() => {
    const count = ['skills', 'projects', 'jobs'].reduce(
        (total, type) => total + ((props.org?.[type as keyof typeof props.org] as any[]) || []).length,
        0
    )

    const suffix =
        count === 1 ? 'ponuka' : count > 1 && count < 5 ? 'ponuky' : 'ponúk'

    return {
        text: `${count} ${suffix}`,
        color: 'secondary'
    }
})

  const location = computed(() => {
    return [props.org.geocity, props.org.country].filter(Boolean).join(', ')
  })

const orgType = computed(() => {
    if (!props.org?.type) return ''
    return orgTypeDictionary[(props.org.type as OrgType) || 'UNKNOWN'] || ''
})

const badgeMainData = computed<BadgeMainType>(() => ({
    text: 'Organizácia',
    color: 'primary'
}))
</script>
